import "./SettingHeaderDes.scss";
import React from "react";

interface IProps {
    title: string;
    description: string;
}

const SettingHeaderDes = (props: IProps) => {
    return (
        <div className="overallSettingHeaderDes">
            <div className="overallSettingHead">{props.title}</div>
            <div className="overallSettingDes">{props.description}</div>
        </div>
    );
};

export default SettingHeaderDes;
